import React, { useEffect } from "react";
import { Table, Switch, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSupplierModel } from "../supplierModel";
import { IVRMSupplierDetail } from "../supplierService";
import { momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";




export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, onDisabled,
    } = useSupplierModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = (code: string) => {
        let supplierEditKey = "13-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    useEffect(() => {
        loadData()
    }, [])
    const columns: ColumnsType<IVRMSupplierDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (text, record, index) => `${index + 1}`,

        }, {
            title: '供应商编码',
            width: 140,
            dataIndex: 'code',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={(e) => { e.stopPropagation(); onLook(record.id) }} />,
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'name',
            render: (text: any, record: any,) => <YhTootip text={text} />,
        }, {
            title: '供应商类型',
            width: 120,
            dataIndex: 'typeName',
        }, {
            title: '供应商简称',
            width: 110,
            dataIndex: 'prefix',
        }, {
            title: '账号',
            width: 110,
            dataIndex: 'userCode',
        }, {
            title: '联系人',
            width: 120,
            dataIndex: 'contact',
            render: (text: any, record: any,) => <YhTootip text={text} />,
        }, {
            title: '联系电话',
            width: 120,
            dataIndex: 'phone',
        }, {
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 140,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        },
        //  {
        //     title: '所属站点',
        //     width: 160,
        //     dataIndex: 'shopName',
        // }, 
        {
            title: '备注',
            // width: 200,
            dataIndex: 'note',
        }, {
            title: '状态',
            width: 100,
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    {/* checked={record.materialenable == 0} */}
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                        // cutDisabled(record,checked)
                    }} />
                </Space>
            ),
        }
    ];




    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id as string}
            size={tableSize}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IVRMSupplierDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
